var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, KompisElement, property } from '@inter-ikea-kompis/web-component';
import { QrCode } from '@inter-ikea-kompis/component-qr-code';
import { Text } from '@inter-ikea-kompis/component-text';
import { Button as SkapaButton, IconButton as SkapaIconButton } from '@ingka/button-webc/passive.js';
import FinancialServicesButtonsStyle from './FinancialServicesButtonsStyle.js';
/**
 * Financial services buttons.
 *
 * @event continueButtonClick When continue planning button is clicked.
 * @event moreInfoClick When read more is clicked.
 */
export default class FinancialServicesButtons extends KompisElement {
    constructor() {
        super(...arguments);
        // Localized information. Deprecated - use "translations" instead.
        this.localizedInformation = null;
        // The translations retrieved from translations service.
        this.translations = null;
        // Disables links. Shows QR code. This attribute should be set to "true" when in a Kiosk.
        this.disableLinks = false;
    }
    render() {
        // We want translations to be required, but since both props to provide translations are optional, this check is needed until localizedInformation is removed.
        if (!this.hasTranslations()) {
            // We can't throw an error because on the first render no props are set.
            return null;
        }
        return html `
			<style>
				${FinancialServicesButtonsStyle.getStyle({
            theme: this.theme
        })}
			</style>
			<div class="buttonContainer">
				${this.getStandardConfiguration()} ${this.getKioskConfiguration()}
			</div>
		`;
    }
    async connectedCallback() {
        this.customElements.define('skapa-button', SkapaButton);
        this.customElements.define('skapa-icon-button', SkapaIconButton);
        this.customElements.define('kompis-text', Text);
        this.customElements.define('kompis-qr-code', QrCode);
        super.connectedCallback();
    }
    hasTranslations() {
        return !!this.translations || !!this.localizedInformation?.translations;
    }
    getTranslations() {
        return this.translations
            ? this.translations
            : this.localizedInformation?.translations;
    }
    getStandardConfiguration() {
        if (this.disableLinks) {
            return null;
        }
        return html `${this.getMoreInfoLink()} ${this.getContinueButton()}`;
    }
    getKioskConfiguration() {
        if (!this.disableLinks) {
            return null;
        }
        return html `${this.getQrCode()} ${this.getContinueButton()}`;
    }
    getContinueButton() {
        const primaryVariant = 'primary';
        return html `<skapa-button
			variant="${primaryVariant}"
			class="continue-button"
			@click="${() => {
            this.dispatchEvent(new CustomEvent('continueButtonClick'));
        }}"
			fluid
		>
			${this.getTranslations().financialServicesContinueButton}
		</skapa-button>`;
    }
    getMoreInfoLink() {
        const secondaryVariant = 'secondary';
        return html `
			<skapa-button
				class="info-button"
				new-window
				href="${this.financingOption.moreInfoLink}"
				variant="${secondaryVariant}"
				@click="${() => {
            this.dispatchEvent(new CustomEvent('moreInfoClick'));
        }}"
				fluid
			>
				${this.financingOption.moreInfoAnchor}
			</skapa-button>
		`;
    }
    getQrCode() {
        return html `<div class="qr-code">
			<kompis-qr-code .url="${this.financingOption.moreInfoLink}"></kompis-qr-code>
			<kompis-text class="qr-code-text" .theme="${this.theme}">
				${this.financingOption.moreInfoAnchor}
			</kompis-text>
		</div>`;
    }
}
__decorate([
    property({ type: Object, required: true })
], FinancialServicesButtons.prototype, "financingOption", void 0);
__decorate([
    property({ type: Object, required: true })
], FinancialServicesButtons.prototype, "theme", void 0);
__decorate([
    property({ type: Object })
], FinancialServicesButtons.prototype, "localizedInformation", void 0);
__decorate([
    property({ type: Object })
], FinancialServicesButtons.prototype, "translations", void 0);
__decorate([
    property({ type: Boolean })
], FinancialServicesButtons.prototype, "disableLinks", void 0);
//# sourceMappingURL=FinancialServicesButtons.js.map